import { Component, Input, OnInit } from '@angular/core';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';

@Component({
	selector: 'app-ctv-dayparts',
	templateUrl: './ctv-dayparts.component.html',
	styleUrls: ['./ctv-dayparts.component.css']
})
export class CtvDaypartsComponent implements OnInit {
	@Input() sectiontitle: string;
	@Input() sectionclass: any;
	@Input() nodatamessage: any;
	@Input() key: string;
	@Input() downloadconfig: any;
	public reloadSubscription;
	public hasData: boolean = true;
	public timezone: string;
	public showLoad: boolean = true;
	public downloadConfiguration: DownloadConfig;
	public colorPalette: ColorPalette;
	public widgetDataSubscription: any;
	public chartData: any;

	public tooltipOptions = {
		animation: 'fade',
		arrow: true,
		duration: 250,
		dynamicTitle: true,
		position: 'top',
		scale: 'small',
		theme: 'light r8-dayparts'
	};

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		if (!this.nodatamessage || this.nodatamessage === 'undefined' || this.nodatamessage === 'null') {
			this.nodatamessage = 'No data to display';
		}
	}

	ngAfterViewInit(): void {
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService
			.processCustomServiceRequest(this.key)
			.subscribe((response: any) => {
				this.showLoad = false;
				this.timezone = response.timezone ? `(${response.timezone})` : '';
				if (response.success && response.data.length > 0) {
					this.hasData = true;
					this.processResponseData(response.data);
				} else {
					this.hasData = false;
					this.chartData = [];
				}
			});
	}

	processResponseData(responseData: any): void {
		let sumOfImpressios = responseData.reduce((a, b) => {
			return a + parseInt(b.impressions);
		}, 0);

		this.chartData = responseData.map((item) => {
			let itemImpressions = parseInt(item.impressions) ? parseInt(item.impressions) : 0;
			item['percent'] = ((itemImpressions / sumOfImpressios) * 100).toFixed(2);
			return item;
		});

		console.log(this.chartData);
	}
}
